import React, {Component} from "react";
import './index.less'
import EventBus from "///utils/eventBus";
export default class PortalContentFun extends Component{
    constructor(props) {
        super(props)
        this.state = {
            title:'平台功能',
            contents:[
                {
                    noHover:{
                        title:"智能对话",
                        icon:require("./images/智能问答-插画2x.png"),
                    },
                    hover:{
                        title:"智能对话",
                        desc1:"支持配置自己特有的知识库实现智能问答，如操作咨询、闲聊、动态数据查询等。",
                        desc2:"支持通过多轮对话与第三方API集成实现自助服务，如语音控制某些界面的操作、隐患的自助填报、目标文件的定位识别等。",
                        icon:'iconpingtaigongneng-zhinengwenda',
                    },
                    // robotPreviewUrl:"http://www.baidu.com",
                    key:"contents1",
                    show:true,
                    index:1,
                },
                {
                    noHover:{
                        title:"知识运营",
                        icon:require("./images/知识运营-插画2x.png"),
                    },
                    hover:{
                        title:"知识运营",
                        desc1:"高效的运营工具可对知识简单快捷地进行分类管理、增删改查。",
                        desc2:"简单的知识学习，帮助人工快速进行负例的发现更正及缺失知识的补充。",
                        desc3:"系统会定期自动进行知识质量的检测，保障知识的持续高质量。",
                        icon:'iconzhishiyunying-icon',
                    },
                    key:"contents2",
                    show:false,
                    index:2,
                },
                {
                    noHover:{
                        title:"人机协作",
                        icon:require("./images/人机协作-插画2x.png"),
                    },
                    hover:{
                        title:"人机协作",
                        desc1:"系统根据一定的准则自动识别警示会话并进行桌面推送提醒，人工接收提醒后，可主动介入会话提供人工服务，不再被动等待。",
                        desc2:"人工客服化被动为主动，既可保证良好的用户体验，又可降低人工服务量，提升智能机器人的价值。",
                        icon:'iconrenjixiezuo',
                    },
                    key:"contents3",
                    show:false,
                    index:3,
                },
            ]
        }
    }

    handlePeview = (robotPreviewUrl) => {
        window.open(robotPreviewUrl,"_blank ");
    }

    handleMouseEnter = (ele) => {
        this.setState({
            contents:JSON.parse(JSON.stringify(this.state.contents.map(item => {
                item.show = ele.index === item.index
                return item
            })))
        })
    }

    bindEvent = () => {
        let _this = this
        EventBus.on('content-tag-fix-flag',(params = {}) => {
            _this.setState({
                contentTagFixFlag:params.contentTagFixFlag
            })
        })
    }

    componentDidMount() {
        this.bindEvent()
    }

    render() {
        let { title , contents } = this.state
        let { handlePeview , handleMouseEnter , onMouseLeave } = this
        return (
            <div className={'portal-content-fun'}>
                <div className={'portal-content-fun-content w1200'} id={'portalFun'}>
                    <h2>{title}</h2>
                    <ul>
                        {contents.map(ele=> {
                            return (
                                <li key={ele.key}
                                    onMouseEnter={() => {handleMouseEnter(ele)}}
                                >
                                    <div
                                        className={'portal-content-fun-content-hover'}
                                        style={{display: ele.show ? 'block' : 'none'}}
                                    >
                                        <span className={`icon iconfont ${ele.hover.icon}`}></span>
                                        {/*<img src={ele.hover.icon} width={80} height={60} style={{padding:'30px 0px'}} alt=""/>*/}
                                        <h3 style={{fontWeight: 'bold',height:"37px"}}>{ele.hover.title}</h3>
                                        <p style={{padding:"0px 18px 12px",textAlign:'left'}}>{ele.hover.desc1}</p>
                                        <p style={{padding:"0px 18px 12px",textAlign:'left'}}>{ele.hover.desc2}</p>
                                        <p style={{padding:"0px 18px 12px",textAlign:'left'}}>{ele.hover.desc3}</p>
                                        {ele.robotPreviewUrl ?
                                            <button className={'g-btn g-btn-default'} onClick={() => {handlePeview(ele.robotPreviewUrl)}}>立即体验</button>
                                            : null
                                        }
                                    </div>
                                    <div
                                        className={'portal-content-fun-content-blur'}
                                        style={{display: !ele.show ? 'block' : 'none'}}
                                    >
                                        <img src={ele.noHover.icon} style={{paddingTop:80,height:200}} alt=""/>
                                        <h3 style={{lineHeight:"80px"}}>{ele.noHover.title}</h3>
                                    </div>
                                </li>
                            )
                        })}
                    </ul>
                </div>
            </div>
        )
    }
}